import { sendEmailVerification } from "firebase/auth";
import React, { FC } from "react";

import { Box, Stack } from "@mui/material";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import SaveButton from "../../components/SaveButton";
import { firebaseAuth } from "../../configs/firebase";
import { logout } from "../../slices/current";
import { pushError, pushSuccess } from "../../slices/notifications";
import { useDispatch } from "../../store";
import { getBaseUrl } from "../../utils/urls";

const VerifyEmail: FC = () => {
  const dispatch = useDispatch();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="50vh"
    >
      <Stack>
        <Alert severity="info">
          <AlertTitle>
            A verification message was sent. Check your email and click the link
            to verify it.
          </AlertTitle>
        </Alert>

        <SaveButton
          fullWidth
          variant="contained"
          onClick={async () => {
            if (firebaseAuth.currentUser) {
              await sendEmailVerification(firebaseAuth.currentUser, {
                url: `${getBaseUrl()}/login`,
              })
                .then(() =>
                  dispatch(
                    pushSuccess(
                      "An email has been sent. Please check your inbox.",
                    ),
                  ),
                )
                .catch((e) => dispatch(pushError(e.message)));
            } else {
              dispatch(pushError("Please login"));
              dispatch(logout());
            }
          }}
        >
          Resend Verification Email
        </SaveButton>
      </Stack>
    </Box>
  );
};

export default VerifyEmail;
